import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Force password change if flagged, kecuali sudah di halaman ganti-sandi
  if (user.must_change_password && !location.pathname.startsWith("/ganti-sandi")) {
    return <Navigate to="/ganti-sandi?first=1" replace />;
  }
  return children;
}
